import { render, staticRenderFns } from "./medicine_refrigerator_dashboard.vue?vue&type=template&id=4ef62350&scoped=true&"
import script from "./medicine_refrigerator_dashboard.vue?vue&type=script&lang=js&"
export * from "./medicine_refrigerator_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./medicine_refrigerator_dashboard.vue?vue&type=style&index=0&id=4ef62350&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef62350",
  null
  
)

export default component.exports